import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import SubNavigationItemTranslation from '@/repositories/data/sidebar/SubNavigationItemTranslation';

export default class SubNavigationItemTranslationRepository extends BaseCrudRepository<
    number,
    SubNavigationItemTranslation,
    SubNavigationItemTranslation
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/sub-navigation-item-translation/');
    }
}
